import React from "react";
import styled from "styled-components";
import { Marker } from "react-map-gl";
import MapPin from "../common/MapPin";

export default React.memo(function Pin(props) {
  return (
    <MapMarker {...props}>
      <MapPin />
    </MapMarker>
  );
});

const MapMarker = styled(Marker)`
  z-index: 9;

  .pulse {
    animation: pulse 2000ms linear infinite;
    transform-origin: 50% 50%;
    fill: ${props => props.theme.palette.primary.main};
  }

  @keyframes pulse {
    0% {
      transform: scale(0);
    }
    60% {
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
`;
